import { buildUserLockTx } from './buildUserLockTx.js';
import { PublicKey } from '@solana/web3.js';
export async function userLock(connection, signer, params, program) {
    const walletPublicKey = new PublicKey(signer.publicKey);
    const tx = await buildUserLockTx(connection, program, walletPublicKey, params);
    let signature;
    try {
        signature = await signer.sendTransaction(tx);
    }
    catch (e) {
        console.error('[SolanaHTLC] sendTransaction failed', e?.message ?? String(e), e?.logs ?? []);
        throw e;
    }
    const res = await connection.confirmTransaction({
        blockhash: tx.recentBlockhash,
        lastValidBlockHeight: tx.lastValidBlockHeight,
        signature,
    });
    if (res?.value.err) {
        console.error('[SolanaHTLC] confirmTransaction error', res.value.err.toString());
        throw new Error(res.value.err.toString());
    }
    return { hash: signature, hashlock: params.hashlock, nonce: params.nonce };
}
